import React, { useState, useEffect } from "react";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import FileViewer from "react-file-viewer";
import { getGUID, getRemainingStringFileName } from "../../common";
import { useLocation } from "react-router-dom";
import { generatePresignedUrl } from "../../../src/api/common-store-api";
import Loader from "../../../src/components/Loader/Loader";

const DocumentView = ({ setDocumentView }) => {
  const [contentUrlData, setContentUrlData] = useState(null);
  const location = useLocation();
  const [id, setId] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    setDocumentView(true);

    return () => {
      setDocumentView(false);
    };
  }, [setDocumentView]);

  const fetchPreviewUrl = async () => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get("accesstoken");
      let docId = queryParams.get("id");

      if (docId) {
        docId = docId.replace(/^"(.*)"$/, "$1").trim();
        setId(docId);
      }
      if (token && docId) {
        localStorage.setItem("access_token", token);
        const getGuid = getGUID(docId);
        const previewUrl = await generatePresignedUrl(getGuid);

        if (previewUrl?.data) {
          //setContentUrlData(previewUrl.data);
          setShowLoader(true);
          console.log(previewUrl?.data, "previewUrl.data Doc");
          setContentUrlData(previewUrl?.data);
          const response = await fetch(previewUrl?.data);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          // Get the file as array buffer
          const arrayBuffer = await response.arrayBuffer();

          // Convert to base64
          const base64 = btoa(
            new Uint8Array(arrayBuffer).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );

          // Create data URL
          const dataUrl = `data:application/pdf;base64,${base64}`;
          // console.log(dataUrl,"amigo am")
          setFileData(dataUrl);
          setShowLoader(false);
        }
      }
    } catch (error) {
      console.error("Error fetching preview URL:", error);
    }
  };

  useEffect(() => {
    fetchPreviewUrl();
  }, [location]);

  const getFileExtension = (filename) => {
    const parts = filename?.split(".");
    return parts?.length > 1 ? parts.pop() : "";
  };

  const fileExtension = getFileExtension(id);
  const isDocFile = fileExtension === "doc" || fileExtension === "docx";
  const isPptFile = fileExtension === "pptx";

  const pptFile = [
    {
      uri: contentUrlData,
      fileType: fileExtension,
    },
  ];

  return (
    <div className="document-preview">
      {contentUrlData && fileData ? (
        isDocFile ? (
          <DocViewer
            documents={[
              {
                uri: contentUrlData,
                fileType: fileExtension,
                fileName: getRemainingStringFileName(id),
              },
            ]}
            pluginRenderers={DocViewerRenderers}
            style={{ width: "100%", height: "100vh", zoom: "117%" }}
            onError={(e) => console.log("Error Documents:", e)}
          />
        ) : isPptFile ? (
          <DocViewer
            pluginRenderers={DocViewerRenderers}
            documents={pptFile}
            config={{
              header: {
                disableHeader: true,
                disableFileName: true,
                retainURLParams: false,
              },
            }}
            style={{ height: "100vh" }}
          />
        ) : (
          <FileViewer
            fileType={fileExtension}
            filePath={fileData}
            style={{ width: "100%", height: "600px" }}
            errorComponent={<div>Error loading file</div>}
            onError={(e) => console.log("Error Documents:", e)}
          />
        )
      ) : (
        <div>
          {/* Loading... */}
          <Loader/>
          </div>
      )}
    </div>
  );
};

export default DocumentView;
